import { useEffect } from "react";
import { AxiosResponse } from "axios";
import { countryFormatter } from "../../../shared/utils";
import { useRequest } from "../../../hooks/useRequest";
import routes from "../../../routes";

export interface BiodiversityApiResponse {
  _id: string;
  id: string;
  projectId: string;
  projectName: string;
  country: string;
  isSold: boolean;
  edgeOrFullBoxArea?: string;
  soldAt: number;
  clientId: string;
  clientName?: string;
  unitSerialNumber: string;
  whatThreeWordsPoint: string;
  individualUnitArea: number;
  projectArea: number;
  serialNumber: string;
  unitArea: number;
  logoUrl: string;
}

function useBiodiversityList(urlSoldQuery: string) {
  const { loading, fetch, response, error } = useRequest();

  useEffect(() => {
    const url = `${routes.api.biodiversity.units.pattern}${urlSoldQuery}`;
    const timeout = 10000;
    fetch("GET", url, timeout);
  }, [urlSoldQuery, fetch]);

  const generateDataGridFormat = (
    biodiversity: AxiosResponse<Array<BiodiversityApiResponse>> | undefined,
  ) => {
    if (biodiversity) {
      return biodiversity.data.map(
        (biodiversityUnit: BiodiversityApiResponse) => ({
          id: biodiversityUnit.id,
          project: biodiversityUnit.projectName,
          country: countryFormatter(biodiversityUnit.country),
          isSold: biodiversityUnit.isSold,
          edgeOrFullBoxArea: biodiversityUnit.edgeOrFullBoxArea,
          unitSerialNumber: biodiversityUnit.unitSerialNumber,
          whatThreeWordsPoint: biodiversityUnit.whatThreeWordsPoint,
          individualUnitArea: biodiversityUnit.individualUnitArea,
          projectTotalArea: biodiversityUnit.projectArea,
          logo: biodiversityUnit.logoUrl,
          client: biodiversityUnit.clientName,
          clientId: biodiversityUnit.clientId,
          soldDate: biodiversityUnit.soldAt,
        }),
      );
    }
    return [];
  };

  return {
    loading,
    biodiversityList: generateDataGridFormat(response),
    error,
  };
}

export default useBiodiversityList;
